import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { PlanLandingResolver } from '@/features/auth/utils/PlanLandingResolver';

export const Route = createFileRoute('/_authenticated/work-orders/$id')({
	component: WorkOrderDetailGuard,
});

function WorkOrderDetailGuard() {
	const { assistantEnabled, businessEnabled, isLoading } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLoading) return;
		if (!businessEnabled) {
			navigate({ to: PlanLandingResolver.resolve({ assistantEnabled, businessEnabled }), replace: true });
		}
	}, [isLoading, assistantEnabled, businessEnabled, navigate]);

	if (isLoading || !businessEnabled) return null;

	return <Outlet />;
}
